export default function FileUploadIcon() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.50014 13.2484H5.62514C5.0047 13.2478 4.39149 13.1152 3.8262 12.8595C3.26091 12.6038 2.75647 12.2308 2.34637 11.7652C1.93628 11.2996 1.6299 10.7521 1.44757 10.1591C1.26524 9.56604 1.21114 8.941 1.28885 8.32545C1.36656 7.70989 1.5743 7.11791 1.8983 6.58878C2.22229 6.05966 2.65513 5.60549 3.16807 5.25644C3.68101 4.90739 4.26232 4.67143 4.87343 4.56422C5.48454 4.45701 6.11146 4.48101 6.71258 4.63462M6.25014 6.99841C6.25024 6.00813 6.48565 5.03204 6.93697 4.15058C7.3883 3.26912 8.04261 2.50752 8.84601 1.92854C9.64941 1.34956 10.5789 0.969768 11.5578 0.820466C12.5368 0.671164 13.5372 0.756623 14.4767 1.0698C15.4162 1.38298 16.2678 1.91491 16.9613 2.62177C17.6549 3.32862 18.1705 4.19016 18.4658 5.1354C18.7611 6.08064 18.8276 7.08251 18.6597 8.05847C18.4918 9.03442 18.0945 9.95652 17.5003 10.7488M9.2235 9.6501L11.8751 6.99838M11.8751 6.99838L14.5268 9.6501M11.8751 6.99838V13.2484"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
